// src/screens/TodayScreen.jsx
import React, { useState } from "react";
import { ScrollArea, SectionHeader, Pill } from "../components/UI";
import EventCard from "../components/EventCard";
import MapView from "../components/MapView";
import { FRIENDS } from "../data/events";

export function TodayScreen({ events, saved, onSave, onOpen, city }) {
  const [filter, setFilter] = useState("all");
  const cats = ["all","party","concert","sports","food","outdoor","wellness"];
  const todayEvs = events.filter(e => e.city === city && (filter === "all" || e.cat === filter));
  const liveCount  = events.filter(e => e.city === city && e.live).length;
  const freeCount  = events.filter(e => e.city === city && e.price === 0).length;

  return (
    <ScrollArea>
      {/* Hero */}
      <div style={{ margin:"12px 16px 0", background:"#7F77DD", borderRadius:14, padding:"14px 15px" }}>
        <div style={{ fontSize:10, color:"#AFA9EC", marginBottom:2 }}>Wednesday, Apr 15 · {city}</div>
        <div style={{ fontSize:16, fontWeight:500, color:"#fff", marginBottom:2 }}>What's on today</div>
        <div style={{ fontSize:11, color:"#AFA9EC" }}>Curated for your city</div>
        <div style={{ display:"flex", gap:7, marginTop:10 }}>
          {[{ n:todayEvs.length, l:"Events" },{ n:liveCount, l:"Live now" },{ n:freeCount, l:"Free" }].map(s => (
            <div key={s.l} style={{ background:"rgba(255,255,255,0.14)", borderRadius:9, padding:"6px 10px", flex:1, textAlign:"center" }}>
              <div style={{ fontSize:16, fontWeight:500, color:"#fff" }}>{s.n}</div>
              <div style={{ fontSize:9, color:"#AFA9EC", marginTop:1 }}>{s.l}</div>
            </div>
          ))}
        </div>
      </div>

      {/* Filters */}
      <div style={{ display:"flex", gap:7, padding:"10px 16px 0", overflowX:"auto" }}>
        {cats.map(c => <Pill key={c} label={c.charAt(0).toUpperCase()+c.slice(1)} active={filter===c} onClick={()=>setFilter(c)}/>)}
      </div>

      <SectionHeader title="Events near you" action="See map"/>
      {todayEvs.length === 0
        ? <div style={{ padding:"20px 16px", fontSize:13, color:"#999" }}>No events found in this category.</div>
        : todayEvs.map(ev => <EventCard key={ev.id} ev={ev} saved={saved.includes(ev.id)} onSave={onSave} onOpen={onOpen}/>)
      }
      <div style={{ height:10 }}/>
    </ScrollArea>
  );
}

// ── Discover ───────────────────────────────────────────────────────────────
// src/screens/DiscoverScreen.jsx
export function DiscoverScreen({ events, saved, onSave, onOpen, city }) {
  const [cat, setCat] = useState("all");
  const [month, setMonth] = useState("Apr");
  const MONTHS = ["Jan","Feb","Mar","Apr","May","Jun","Jul","Aug","Sep","Oct","Nov","Dec"];
  const CATS   = ["all","party","concert","sports","festivals","food","outdoor","wellness"];
  const filtered = events.filter(e => e.city === city && (cat === "all" || e.cat === cat));
  const featured = events.find(e => e.id === "jazz" && e.city === city);

  return (
    <ScrollArea>
      <div style={{ display:"flex", gap:7, padding:"8px 16px 0", overflowX:"auto" }}>
        {CATS.map(c => <Pill key={c} label={c.charAt(0).toUpperCase()+c.slice(1)} active={cat===c} onClick={()=>setCat(c)}/>)}
      </div>
      <div style={{ display:"flex", gap:6, padding:"6px 16px 0", overflowX:"auto" }}>
        {MONTHS.map(m => <Pill key={m} label={m} active={month===m} onClick={()=>setMonth(m)} style={{ fontSize:11, padding:"4px 11px" }}/>)}
      </div>

      {featured && cat === "all" && (
        <div onClick={()=>onOpen(featured.id)} style={{ margin:"10px 16px 0", borderRadius:14, overflow:"hidden", height:155, display:"flex", alignItems:"flex-end", padding:13, cursor:"pointer", position:"relative", background:featured.grad }}>
          <div style={{ position:"absolute", inset:0, background:"rgba(35,25,75,0.42)" }}/>
          <div style={{ position:"relative", zIndex:1 }}>
            <div style={{ fontSize:10, color:"#AFA9EC", marginBottom:3 }}>Featured this month</div>
            <div style={{ fontSize:17, fontWeight:500, color:"#fff", marginBottom:2 }}>{featured.title}</div>
            <div style={{ fontSize:11, color:"rgba(255,255,255,0.85)" }}>{featured.date} · {featured.venue}</div>
          </div>
        </div>
      )}

      <div style={{ marginTop:10 }}>
        {filtered.length === 0
          ? <div style={{ padding:"20px 16px", fontSize:13, color:"#999" }}>No events found.</div>
          : filtered.map(ev => <EventCard key={ev.id} ev={ev} saved={saved.includes(ev.id)} onSave={onSave} onOpen={onOpen}/>)
        }
      </div>
      <div style={{ height:10 }}/>
    </ScrollArea>
  );
}

// ── Map ────────────────────────────────────────────────────────────────────
export function MapScreen({ events, saved, onSave, onOpen, city }) {
  const [filter, setFilter]   = useState("all");
  const [selected, setSelected] = useState(null);
  const CATS = ["all","party","concert","sports","food","outdoor"];
  const cityEvs = events.filter(e => e.city === city);

  return (
    <ScrollArea>
      <div style={{ display:"flex", gap:7, padding:"8px 16px 0", overflowX:"auto" }}>
        {CATS.map(c => <Pill key={c} label={c.charAt(0).toUpperCase()+c.slice(1)} active={filter===c} onClick={()=>{ setFilter(c); setSelected(null); }}/>)}
      </div>
      <MapView events={cityEvs} filter={filter} onPinClick={(ev)=>setSelected(ev)}/>

      {selected && (
        <div style={{ margin:"8px 16px 0", background:"#fff", borderRadius:13, border:`1.5px solid ${selected.color}`, padding:12 }}>
          <div style={{ display:"flex", justifyContent:"space-between", alignItems:"flex-start" }}>
            <div>
              <div style={{ fontSize:13, fontWeight:500, color:"#111", marginBottom:2 }}>{selected.title}</div>
              <div style={{ fontSize:11, color:"#666" }}>{selected.venue} · {selected.priceLabel}</div>
            </div>
            <button onClick={()=>setSelected(null)} style={{ background:"none", border:"none", cursor:"pointer", fontSize:18, color:"#999" }}>×</button>
          </div>
          <div style={{ display:"flex", gap:7, marginTop:9 }}>
            <button onClick={()=>onOpen(selected.id)} style={{ flex:1, background:"#7F77DD", color:"#fff", border:"none", borderRadius:20, padding:9, fontSize:12, cursor:"pointer" }}>View event</button>
            <button onClick={()=>onSave(selected.id)} style={{ background:"none", color:saved.includes(selected.id)?"#7F77DD":"#666", border:`0.5px solid ${saved.includes(selected.id)?"#7F77DD":"rgba(0,0,0,0.18)"}`, borderRadius:20, padding:"9px 14px", fontSize:12, cursor:"pointer" }}>
              {saved.includes(selected.id) ? "Saved ✓" : "Save"}
            </button>
          </div>
        </div>
      )}

      <SectionHeader title={`Nearby · ${city}`} action={`${cityEvs.length} events`}/>
      <div style={{ display:"flex", gap:9, padding:"0 16px", overflowX:"auto", paddingBottom:4 }}>
        {(filter==="all"?cityEvs:cityEvs.filter(e=>e.cat===filter)).map(ev=>(
          <div key={ev.id} onClick={()=>setSelected(ev)} style={{ flexShrink:0, width:138, background:"#fff", borderRadius:12, border:"0.5px solid rgba(0,0,0,0.1)", overflow:"hidden", cursor:"pointer" }}>
            <div style={{ height:66, background:ev.grad, position:"relative" }}>
              {ev.live && <div style={{ position:"absolute", top:5, left:5, width:6, height:6, borderRadius:"50%", background:"#1D9E75" }}/>}
            </div>
            <div style={{ padding:"6px 8px 8px" }}>
              <div style={{ fontSize:11, fontWeight:500, color:"#111", marginBottom:1, overflow:"hidden", textOverflow:"ellipsis", whiteSpace:"nowrap" }}>{ev.title.split(" ").slice(0,3).join(" ")}</div>
              <div style={{ fontSize:9, color:"#999", marginBottom:3 }}>{ev.live?"Open now":"Upcoming"}</div>
              <span style={{ fontSize:9, padding:"2px 7px", borderRadius:20, background:ev.color+"22", color:ev.color }}>{ev.cat}</span>
            </div>
          </div>
        ))}
      </div>
      <div style={{ height:10 }}/>
    </ScrollArea>
  );
}

// ── Social ─────────────────────────────────────────────────────────────────
export function SocialScreen({ onOpenEvent }) {
  const [tab, setTab] = useState("activity");
  return (
    <ScrollArea>
      <div style={{ display:"flex", gap:7, padding:"10px 16px 0" }}>
        {[["activity","Activity"],["invites","Invites (2)"],["going","Going"]].map(([id,lbl])=>(
          <Pill key={id} label={lbl} active={tab===id} onClick={()=>setTab(id)}/>
        ))}
      </div>

      {tab === "activity" && FRIENDS.map(f=>(
        <div key={f.av} style={{ display:"flex", gap:9, padding:"11px 16px", borderBottom:"0.5px solid rgba(0,0,0,0.07)" }}>
          <div style={{ width:34, height:34, borderRadius:"50%", background:f.bg, color:f.tc, display:"flex", alignItems:"center", justifyContent:"center", fontSize:11, fontWeight:500, flexShrink:0 }}>{f.av}</div>
          <div>
            <div style={{ fontSize:12, fontWeight:500, color:"#111" }}>{f.name}</div>
            <div style={{ fontSize:11, color:"#666", marginTop:1 }}>{f.status}</div>
            <div style={{ fontSize:10, color:"#999", marginTop:3 }}>{f.time}</div>
          </div>
        </div>
      ))}

      {tab === "invites" && (
        <div style={{ padding:"10px 16px 0" }}>
          {[{name:"Kai M",ev:"Afrobeats Rooftop Party · Tonight · R250"},{name:"Thabo N",ev:"Stormers vs Lions · Apr 20 · From R150"}].map((inv,i)=>(
            <div key={i} style={{ background:"#fff", borderRadius:13, border:"0.5px solid rgba(0,0,0,0.1)", padding:"11px 13px", marginBottom:9 }}>
              <div style={{ fontSize:12, fontWeight:500, color:"#111", marginBottom:5 }}>{inv.name} invited you</div>
              <div style={{ fontSize:12, color:"#666", background:"#f5f5f5", borderRadius:9, padding:"7px 9px", marginBottom:7 }}>{inv.ev}</div>
              <div style={{ display:"flex", gap:7 }}>
                <button style={{ flex:1, background:"#7F77DD", color:"#fff", border:"none", borderRadius:20, padding:8, fontSize:11, cursor:"pointer" }}>Accept</button>
                <button style={{ flex:1, background:"none", color:"#666", border:"0.5px solid rgba(0,0,0,0.18)", borderRadius:20, padding:8, fontSize:11, cursor:"pointer" }}>Decline</button>
              </div>
            </div>
          ))}
        </div>
      )}

      {tab === "going" && (
        <div style={{ padding:"10px 16px" }}>
          <div style={{ fontSize:11, fontWeight:500, color:"#111", marginBottom:7 }}>This week</div>
          <div style={{ background:"#fff", borderRadius:13, border:"0.5px solid rgba(0,0,0,0.1)", padding:"10px 12px" }}>
            <div style={{ display:"flex", gap:9, alignItems:"center" }}>
              <div style={{ width:36, height:36, borderRadius:9, background:"linear-gradient(135deg,#D85A30,#BA7517)", flexShrink:0 }}/>
              <div><div style={{ fontSize:12, fontWeight:500, color:"#111" }}>Afrobeats Rooftop Party</div><div style={{ fontSize:10, color:"#999", marginTop:1 }}>Tonight · Kai, Thabo going</div></div>
            </div>
          </div>
        </div>
      )}
      <div style={{ height:10 }}/>
    </ScrollArea>
  );
}

// ── Profile ────────────────────────────────────────────────────────────────
export function ProfileScreen({ user, saved, events, onEdit, onCreateEvent }) {
  const savedEvs = events.filter(e => saved.includes(e.id));
  const initials = (user.name||"?").split(" ").map(w=>w[0]).join("").toUpperCase().slice(0,2);
  return (
    <ScrollArea>
      <div style={{ background:"#fff", padding:"20px 16px 14px", textAlign:"center", borderBottom:"0.5px solid rgba(0,0,0,0.08)" }}>
        <div style={{ width:60, height:60, borderRadius:"50%", background:"#AFA9EC", color:"#26215C", display:"flex", alignItems:"center", justifyContent:"center", fontSize:20, fontWeight:500, margin:"0 auto 9px" }}>{initials}</div>
        <div style={{ fontSize:15, fontWeight:500, color:"#111" }}>{user.name}</div>
        <div style={{ fontSize:11, color:"#666", marginTop:2 }}>{user.city} · @{(user.name||"user").toLowerCase().replace(/\s/g,"")}</div>
        <div style={{ display:"flex", justifyContent:"center", gap:6, marginTop:8, flexWrap:"wrap" }}>
          <span style={{ fontSize:10, padding:"3px 10px", borderRadius:20, background:"#EEEDFE", color:"#534AB7" }}>{user.vibe||"Explorer"}</span>
          <span style={{ fontSize:10, padding:"3px 10px", borderRadius:20, background:"#E1F5EE", color:"#0F6E56" }}>Music lover</span>
        </div>
        <div style={{ display:"flex", gap:8, justifyContent:"center", marginTop:10 }}>
          <button onClick={onEdit} style={{ fontSize:11, background:"none", border:"0.5px solid rgba(0,0,0,0.18)", borderRadius:20, padding:"5px 14px", cursor:"pointer", color:"#666" }}>Edit profile</button>
          <button onClick={onCreateEvent} style={{ fontSize:11, background:"#7F77DD", border:"none", borderRadius:20, padding:"5px 14px", cursor:"pointer", color:"#fff" }}>+ Create event</button>
        </div>
      </div>

      <div style={{ display:"flex", justifyContent:"space-around", padding:12, background:"#fff", margin:"8px 16px", borderRadius:13, border:"0.5px solid rgba(0,0,0,0.08)" }}>
        {[{n:24,l:"Attended"},{n:savedEvs.length,l:"Saved"},{n:5,l:"Friends"},{n:12,l:"Reviews"}].map(s=>(
          <div key={s.l} style={{ textAlign:"center" }}>
            <div style={{ fontSize:17, fontWeight:500, color:"#111" }}>{s.n}</div>
            <div style={{ fontSize:10, color:"#999", marginTop:1 }}>{s.l}</div>
          </div>
        ))}
      </div>

      {savedEvs.length > 0 && (
        <>
          <SectionHeader title="Saved events"/>
          <div style={{ display:"grid", gridTemplateColumns:"1fr 1fr", gap:10, padding:"0 16px" }}>
            {savedEvs.map(ev=>(
              <div key={ev.id} style={{ borderRadius:11, overflow:"hidden", border:"0.5px solid rgba(0,0,0,0.1)" }}>
                <div style={{ height:58, background:ev.grad }}/>
                <div style={{ padding:"6px 8px", background:"#fff" }}>
                  <div style={{ fontSize:11, fontWeight:500, color:"#111", overflow:"hidden", textOverflow:"ellipsis", whiteSpace:"nowrap" }}>{ev.title}</div>
                  <div style={{ fontSize:10, color:"#999", marginTop:1 }}>{ev.date}</div>
                </div>
              </div>
            ))}
          </div>
        </>
      )}
      <div style={{ height:10 }}/>
    </ScrollArea>
  );
}
